import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import OSS from 'ali-oss';
import { connect } from 'react-redux';
import { useDropzone } from 'react-dropzone';
import { confirm, alert, networkErr, axiosInterceptorsConfig, dealWithChildPage, checkFolderExist, putObject, listOSSDir, calcSize } from '../utils';
import { updateFileList, updateFileSubmitStatus } from '../store/file';
import Meta from './meta';
import AlertHighLight from '../components/alert-highLight';
import FileInfo from '../components/file-info';
import { URL, host } from '../constants';
import { initWs } from '../websocket';
import { IFileInfo } from '../type';

const fileUploadText = '选择文件上传';
let fileNumber = 0,
  files: File[];
let startToUploadFile = false;
let fileOverride = false;

const FileServer = ({
  data,
  fileSubmitStatus,
  fileList,
}: {
  data: { fileList: IFileInfo[]; isChildPageFromServer: boolean; breadCrumbs: { link: string; text: string }[] };
  fileSubmitStatus: string;
  fileList: IFileInfo[];
}) => {
  const newFolderRef = useRef<HTMLInputElement>(null);
  const OSSRef = useRef({
    isOSS: false,
    OSSFolder: '',
  });

  const [update, setUpdate] = useState(Date.now());
  const [homepageLink, setHomepageLink] = useState('');

  useEffect(() => {
    setHomepageLink(host);
  }, []);

  useEffect(() => {
    if (location.pathname === '/' && typeof window !== 'undefined') {
      window.location.href = '/files';
    } else {
      axiosInterceptorsConfig();
      console.log('data?.fileList', data?.fileList);
      $dispatch(updateFileList(data?.fileList || []));
      initWs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.pathname === '/files/OSS' || /^\/files\/OSS\//.test(location.pathname)) {
      OSSRef.current.isOSS = true;
      OSSRef.current.OSSFolder = location.pathname.replace(/^\/files\//, '');
      console.info('OSSRef.current.OSSFolder', OSSRef.current.OSSFolder);
      listOSSDir(OSSRef.current.OSSFolder ? `${OSSRef.current.OSSFolder}/` : '')
        .then((res) => {
          const fileLists: IFileInfo[] = [];
          if (Array.isArray(res.prefixes)) {
            const folders = res.prefixes.map((item) => {
              const filename = formatFilename(item);
              return {
                atimeMs: Date.now(),
                filename,
                originFilename: item,
                isFolder: true,
                fileSize: 0,
                ino: 0,
              };
            });
            fileLists.push(...folders);
          }
          if (Array.isArray(res.objects)) {
            const files = res.objects
              .filter((item) => {
                return item.name !== OSSRef.current.OSSFolder + '/';
              })
              .map((item) => {
                const filename = formatFilename(item.name);
                return {
                  atimeMs: item.lastModified as unknown as number,
                  fileSize: item.size,
                  filename,
                  originFilename: item.name,
                  isFolder: false,
                  filePath: item.url,
                  ino: 0,
                };
              });
            fileLists.push(...files);
          }
          $dispatch(updateFileList(fileLists));
        })
        .catch((err) => {
          console.error('listOSSDir err', err);
          alert('获取oss文件失败');
        });
    }
  }, [update]);

  const formatFilename = (name: string) => {
    const filename = name.replace(OSSRef.current.OSSFolder, '').replace(/\//g, '');
    return filename;
  };

  const onDrop = (acceptedFiles: File[]) => {
    if (!acceptedFiles || !acceptedFiles[0]) {
      alert('没有待上传的文件');
    } else {
      fileNumber = acceptedFiles.length - 1;
      files = acceptedFiles;
      submitFile();
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const submitFile = () => {
    const file = files[fileNumber];
    if (/#|%|\\|\//g.test(file.name)) {
      alert('文件名不能包含%或#或\\或/');
      return;
    } else if (file.size >= 4 * 1024 * 1024 * 1024) {
      alert(`文件大小不可以超过4GB, 该文件大小：${calcSize(file.size)}`);
      return;
    }
    if (!startToUploadFile) {
      //forbid upload more times
      startToUploadFile = true;
      const filename = file.name;
      let overwriteSameFilename = false;
      $dispatch(updateFileSubmitStatus(fileUploadText));
      for (const index in fileList) {
        if (fileList[index].filename === filename) {
          overwriteSameFilename = true;
          confirm(
            `提示`,
            <AlertHighLight textFragment={`已经存在 <span class="delete-alert">${filename}</span>(${Number(index) + 1}) ，上传将覆盖原文件`} />,
            '确定',
            // eslint-disable-next-line no-loop-func
            () => {
              fileOverride = true;
              return uploadFile(file);
            },
            // eslint-disable-next-line no-loop-func
            () => {
              startToUploadFile = false;
              return;
            },
          );
        }
      }
      if (!overwriteSameFilename) {
        uploadFile(file);
      }
    } else {
      alert('请勿重复上传');
    }
  };

  const uploadFile = async (file: File) => {
    try {
      const filename = file.name;
      $dispatch(updateFileSubmitStatus(`${filename} 正在上传...`));
      if (OSSRef.current.isOSS) {
        uploadOSSFile(file);
      } else {
        const formData = new FormData();
        formData.append('currentFolder', location.pathname);
        formData.append('files', file);
        const xhr = new XMLHttpRequest();
        xhr.upload.addEventListener('progress', uploadProgress.bind(this, filename), false);
        xhr.addEventListener('error', uploadFailed, false);
        xhr.open('POST', URL.upload);
        xhr.onreadystatechange = function () {
          startToUploadFile = false;
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              // alert(filename + "上传成功！");
              $dispatch(updateFileSubmitStatus(fileUploadText));
              fileNumber--;
              if (fileNumber >= 0) {
                $dispatch(updateFileSubmitStatus(`正在读取：${files[fileNumber].name}`));
                setTimeout(() => {
                  return submitFile();
                }, 1000);
              } else {
                files = [];
                if (fileOverride) {
                  fileOverride = false;
                  // alert('上传成功');
                }
                return;
              }
            } else {
              console.error('xhr.onreadystatechange not 200, xhr.status', xhr.status, 'xhr.responseText', xhr.responseText);
              if (xhr.responseText) {
                try {
                  const responseText = JSON.parse(xhr.responseText);
                  if (responseText && responseText.result) {
                    if (responseText.result.errText === 'illegal_filename') {
                      alert('非法的文件名');
                    } else if (responseText.result.errText === 'more_than_4gb') {
                      alert('文件大小超过4GB');
                    }
                  }
                } catch (err) {
                  //
                }
              }
              alert('上传失败');
              $dispatch(updateFileSubmitStatus(fileUploadText));
              startToUploadFile = false;
            }
          }
        };
        xhr.send(formData);
      }
    } catch (err) {
      alert('上传失败');
      $dispatch(updateFileSubmitStatus(fileUploadText));
      startToUploadFile = false;
      networkErr(err as Error);
    }
  };

  const uploadProgress = (uploadFilename: string, evt: { lengthComputable: any; loaded: number; total: number }) => {
    if (evt.lengthComputable) {
      const percentComplete = Math.round((evt.loaded * 100) / evt.total);
      $dispatch(updateFileSubmitStatus(`${percentComplete.toString()}% - ${uploadFilename}`));
    } else {
      startToUploadFile = false;
      $dispatch(updateFileSubmitStatus(fileUploadText));
    }
  };

  const uploadFailed = (evt: Event) => {
    alert('上传失败');
    startToUploadFile = false;
    $dispatch(updateFileSubmitStatus(fileUploadText));
    console.error('上传失败', evt);
  };

  const uploadOSSFile = (file: File) => {
    return putObject(file, OSSRef.current.OSSFolder, file.name)
      .then(() => {
        setUpdate(Date.now());
        $dispatch(updateFileSubmitStatus(fileUploadText));
        fileNumber--;
        if (fileNumber >= 0) {
          $dispatch(updateFileSubmitStatus(`正在读取：${files[fileNumber].name}`));
          setTimeout(() => {
            return submitFile();
          }, 1000);
        } else {
          files = [];
          if (fileOverride) {
            fileOverride = false;
          }
          alert('上传成功');
          return;
        }
      })
      .catch((err) => {
        console.error('uploadOSSFile err', err);
        alert('上传失败');
      })
      .finally(() => {
        startToUploadFile = false;
        $dispatch(updateFileSubmitStatus(fileUploadText));
      });
  };

  const newFolder = () => {
    confirm('新建文件夹', modalElement(), '确定', addNewFolder);
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.keyCode === 13) {
      addNewFolder();
    }
  };

  const modalElement = () => {
    return (
      <div className='modal-folder'>
        <div className='content'>
          <input
            size={26}
            placeholder='put your text here'
            className='folder-input-component'
            ref={newFolderRef}
            //@ts-ignore
            onKeyDown={handleKeyDown}
            autoFocus={true}
          />
        </div>
      </div>
    );
  };

  const addNewFolder = () => {
    let { value } = newFolderRef.current!;
    const exist = checkFolderExist(fileList, value);
    if (exist) {
      return alert('文件夹已存在');
    }
    value = value.trim();
    if (!value) {
      return alert('请输入文件夹名称');
    }
    if (OSSRef.current.isOSS) {
      //@ts-ignore
      return putObject(new OSS.Buffer('folder'), OSSRef.current.OSSFolder, value + '/')
        .then(() => {
          setUpdate(Date.now());
        })
        .catch((err) => {
          alert('文件夹创建失败');
          console.error('创建文件夹过程中发生了错误', err);
          networkErr(err);
        });
    } else {
      if (!/^[\u4e00-\u9fa5\w\s.]+$/.test(value)) {
        return alert('仅支持数字，字母，下划线，点号，汉字和空格');
      }
      const { pathname } = dealWithChildPage(value);
      return axios
        .post(URL.newFolder, { pathname, currentFolder: location.pathname })
        .then(() => {
          // alert("文件夹创建成功");
        })
        .catch((err) => {
          alert('文件夹创建失败');
          console.error('创建文件夹过程中发生了错误', err);
          networkErr(err);
        });
    }
  };

  const renderBreadcrumb = () => {
    const { breadCrumbs } = data;
    if (breadCrumbs) {
      return (
        <div className='breadcrumb'>
          {breadCrumbs.map((crumb, index) => (
            <div className='breadcrumb-item' key={index}>
              <span className='breadcrumb-item-symbol'>{index !== 0 ? '/' : ''}</span>
              {crumb.link ? (
                <a href={crumb.link} className='breadcrumb-item-text'>
                  {crumb.text}
                </a>
              ) : (
                crumb.text
              )}
            </div>
          ))}
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div className='container'>
      <Meta TITLE='欢迎使用文件服务器' META_DESCRIPTION='META_DESCRIPTION' META_KEYWORDS='META_KEYWORDS' noIndex={false} />
      <div className='file-server'>
        <div className='head'>
          <a className='file-list-text' href={homepageLink} target='_self'>
            文件列表 ({fileList.length})
          </a>
        </div>
        <div className='upload-area'>
          <div className='select-files' {...getRootProps()}>
            <input {...getInputProps()} multiple={true} />
            <div className='submit-status'>{fileSubmitStatus}</div>
          </div>
        </div>
        <div className='new-folder' onClick={newFolder}>
          新建文件夹
        </div>
        {data.isChildPageFromServer && renderBreadcrumb()}
        <div className='content'>
          {fileList.length
            ? fileList.map((item, index) => (
                <FileInfo fileInfo={item} key={index} num={index} fileList={fileList} isOSS={OSSRef.current.isOSS} setUpdate={setUpdate} />
              ))
            : null}
        </div>
        <img className='background-pic' src='/static/background.svg' alt='' />
      </div>
    </div>
  );
};

FileServer.getInitialProps = (props: { res: any }) => {
  const { res } = props;
  return {
    data: res.locals.file,
  };
};

const mapStateToProps = (state: { file: { fileList: IFileInfo[]; fileSubmitStatus: string } }) => {
  return {
    fileList: state.file.fileList,
    fileSubmitStatus: state.file.fileSubmitStatus,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FileServer);
